// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as OutboundOrderDashboardCmp from "./components/OutboundOrderDashboardCmp.bs.js";
import * as OrderDashboardStateMachine from "../../../app/order/OrderDashboardStateMachine.bs.js";
import * as NLOrderDashboardAssetsManager from "../../assets/NLOrderDashboardAssetsManager.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

NLOrderDashboardAssetsManager.importCss(undefined);

function OutboundOrderDashboardContainer(Props) {
  var order_crn = Props.order_crn;
  var is_edit_order_open = Props.is_edit_order_open;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer((function (state, action) {
          return OrderDashboardStateMachine.reducer(action, state);
        }), /* LoadingData */0);
  var dispatch = match$1[1];
  var state = match$1[0];
  React.useEffect((function () {
          OrderDashboardStateMachine.fetchBaseData(order_crn, dispatch, country);
          
        }), []);
  React.useEffect((function () {
          if (typeof state !== "number" && state.TAG === /* Dashboard */0) {
            switch (state.tickets.TAG | 0) {
              case /* Loading */0 :
                  OrderDashboardStateMachine.fetchTickets(order_crn, dispatch)(country);
                  break;
              case /* Live */1 :
              case /* Error */2 :
                  break;
              
            }
          }
          if (typeof state !== "number" && state.TAG === /* Dashboard */0 && country.TAG === /* India */1) {
            switch (state.scheduled_order_data.TAG | 0) {
              case /* Loading */0 :
                  OrderDashboardStateMachine.fetchOrderSchedule(order_crn, country, dispatch);
                  break;
              case /* Live */1 :
              case /* Error */2 :
                  break;
              
            }
          }
          
        }), [state]);
  if (typeof state === "number") {
    return React.createElement(CircularLoader$Catalyst.make, {});
  } else if (state.TAG === /* Dashboard */0) {
    return React.createElement(OutboundOrderDashboardCmp.make, {
                order_crn: order_crn,
                order_details: state.order_details,
                order_fare: state.order_fare,
                user: state.user,
                tickets: state.tickets,
                is_edit_order_open: is_edit_order_open,
                scheduled_order_data: state.scheduled_order_data
              });
  } else {
    return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: state._0
              });
  }
}

var make = OutboundOrderDashboardContainer;

export {
  make ,
  
}
/*  Not a pure module */
